import CheckCircleIcon from '@heroicons/react/outline/esm/CheckCircleIcon.js'
import ExclamationCircleIcon from '@heroicons/react/outline/esm/ExclamationCircleIcon.js'
import RefreshIcon from '@heroicons/react/outline/esm/RefreshIcon.js'

import { SupportedIconNames } from './types.js'

interface OutlineIconProps {
  name: SupportedIconNames
}
export const OutlineIcon = ({ name }: OutlineIconProps) => {
  switch (name) {
    case SupportedIconNames.RefreshIcon:
      return <RefreshIcon />
    case SupportedIconNames.CheckCircleIcon:
      return <CheckCircleIcon />
    case SupportedIconNames.ExclamationCircleIcon:
      return <ExclamationCircleIcon />
    case SupportedIconNames.ArrowsRightLeftIcon:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"
          />
        </svg>
      )
    default: {
      // Code should never reach the default case
      const exhaustiveCheck: never = name
      return exhaustiveCheck
    }
  }
}
